import React, { Component } from "react";
import Slider from "react-slick";
import styles from "./index.module.scss";

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div className={`${styles.arrow} ${styles.nextArrow}`} onClick={onClick}>
      <img src="/images/right_arrow.png" alt="" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div className={`${styles.arrow} ${styles.prevArrow}`} onClick={onClick}>
      <img src="/images/left_arrow.png" alt="" />
    </div>
  );
}

export default class Index extends Component {
  render() {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };
    const { data } = this.props;
    return (
      <div>
        <Slider {...settings}>
          {data.map(item => (
            <div key={item}>
              <div className={styles.img_container}>
                <img src={item} alt="" />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    );
  }
}
